document.addEventListener("DOMContentLoaded", function () {

  const section = document.querySelector(".categoria-on");
  if (!section) return;

  const items = section.querySelectorAll(".categoria-item");
  const wrapper = section.querySelector(".categoria-on-icons");
  const dotsContainer = section.querySelector(".categoria-on-dots");

  if (!items.length) return;

  // =========================
  // Activar categoría
  // =========================
  function setActiveByIndex(index) {
    items.forEach((el, i) => el.classList.toggle("active", i === index));

    if (dotsContainer) {
      const dots = dotsContainer.querySelectorAll("span");
      dots.forEach((d, i) => d.classList.toggle("active", i === index));
    }
  }

  // =========================
  // Emitir evento global
  // =========================
  function emitirEventoCategoria(handle) {
    window.__categoriaOnSelected = handle;
    document.dispatchEvent(
      new CustomEvent("categoriaSeleccionada", {
        detail: { categoria: handle }
      })
    );
  }

  // =========================
  // Click categoría
  // =========================
  items.forEach((item, index) => {

    item.addEventListener("click", function () {

      setActiveByIndex(index);

      const handle = this.dataset.collection;
      emitirEventoCategoria(handle);

      // Centrar en mobile
      if (window.innerWidth < 750 && wrapper) {
        const itemRect = item.getBoundingClientRect();
        const wrapRect = wrapper.getBoundingClientRect();
        const delta = (itemRect.left + itemRect.width / 2) - (wrapRect.left + wrapRect.width / 2);
        wrapper.scrollBy({ left: delta, behavior: "smooth" });
      }

    });

  });

  // =========================
  // Auto activar primera categoría
  // =========================
// No activar ninguna por defecto
window.__categoriaOnSelected = null;

  // =========================
  // Carrusel Mobile (solo visual)
  // =========================
  if (window.innerWidth < 750 && dotsContainer) {
    dotsContainer.innerHTML = "";
    items.forEach(() => {
      const dot = document.createElement("span");
      dotsContainer.appendChild(dot);
    });
    setActiveByIndex(0);
  }

});